// extracted by mini-css-extract-plugin
export var columnItem = "_b3-3";
export var columnItemDraggable = "_b3-4";
export var dragHandle = "_b3-0";
export var dragHandleHovered = "_b3-1";
export var dropdown = "_b3-5";
export var dropdownContent = "_b3-7";
export var dropdownInner = "_b3-6";
export var filterDropdownHeader = "_b3-8";
export var icon = "_b3-2";
export var sectionDivider = "_b3-9";